const refundAnalysisStatus = {
  TOTALLY_ACCEPTED: 'TOTALLY_ACCEPTED',
  PARTIALLY_ACCEPTED: 'PARCIALlY_ACCEPTED',
  REJECTED: 'REJECTED'
};

module.exports = refundAnalysisStatus;
